import { getCustomData } from '../App/Selectors';

export const getSelectedInstanceId = (state) => state.machineInstance.selectedInstanceId;

export const getMachineInstances = (state) => getCustomData(state).instances || [];

export const canAddMoreMachines = (state) => getMachineInstances(state).length < 10;

export const getMachineSize = (state) => {
  const { length, width } = getCustomData(state);
  return {
    width: parseFloat(width) * 0.001,
    length: parseFloat(length),
  };
};
